import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {Alert} from "./alert";

@Injectable()
export class AlertService {
    private alertsSubject = new BehaviorSubject<Alert[]>([]);
    alerts$ = this.alertsSubject.asObservable();

    showAlert(type: string, message: string, timeout: number | null = 5000) {
        const currentAlerts = this.alertsSubject.value;
        const newAlert: Alert = {type, msg: message};
        this.alertsSubject.next([...currentAlerts, newAlert]);

        if (timeout) {
            setTimeout(() => {
                const index = this.alertsSubject.value.findIndex(x => x === newAlert);
                if (index >= 0) {
                    this.closeAlert(index)
                }
            }, timeout);
        }
    }

    closeAlert(index: number) {
        const currentAlerts = this.alertsSubject.value;
        currentAlerts.splice(index, 1);
        this.alertsSubject.next([...currentAlerts]);
    }

    clearAlerts() {
        this.alertsSubject.next([]);
    }
}
